import { render, staticRenderFns } from "./UploadAdjustt.vue?vue&type=template&id=46efdd02&scoped=true"
import script from "./UploadAdjustt.vue?vue&type=script&lang=js"
export * from "./UploadAdjustt.vue?vue&type=script&lang=js"
import style0 from "./UploadAdjustt.vue?vue&type=style&index=0&id=46efdd02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46efdd02",
  null
  
)

export default component.exports